import { GQL_ID, PlaceOrderResult } from '@@types'
import { gql, useMutation } from '@apollo/client'

interface PlaceOrderVariables {
  order_id: GQL_ID
}

interface PlaceOrderMutation {
  placeOrder: PlaceOrderResult
}

export const GQL_MUTATION_PLACE_ORDER = gql`
  mutation placeOrder($order_id: ID!) {
    placeOrder(order_id: $order_id) {
      error_code
      order_id
      placed
      message
    }
  }
`

export const useMutatePlaceOrder = () =>
  useMutation<PlaceOrderMutation, PlaceOrderVariables>(GQL_MUTATION_PLACE_ORDER)
